export default __webpack_public_path__ + "static/media/bgTop.94f8a035.png";